import React from 'react';
import moment from 'moment';
import CheckboxField from 'components/pure/utils/form/CheckboxField';
import MailActions from 'actions/inbox/MailActions';
import InputField from 'components/pure/utils/form/InputField';
import ToggleField from 'components/pure/utils/form/ToggleField';
import DateRange from 'components/pure/utils/form/DateRange';
import './FilteringToolbar.styl';

// TODO: a must be replaced with button and eslint ignore must be removed
/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
export default class FilteringToolbar extends React.PureComponent {
  render() {
    const {onUpdateFilters, filters} = this.props;
    const maxDate = moment();

    return (
      <div className="mail-toolbar mail-filtering-toolbar">
        <CheckboxField checked={false} onCheck={MailActions.selectAll} />
        <div className="filters">
          <div className="filter-input-group">
            <div className="filter-spacing-container">
              <InputField
                value={filters.searchTerms || ''}
                placeholder="Search team member or call"
                onChange={searchTerms => onUpdateFilters({searchTerms})}
              />
              <DateRange
                maxDate={maxDate}
                startDate={filters.startDate}
                endDate={filters.endDate}
                onUpdateRange={onUpdateFilters}
                defaultEndDate={maxDate}
              />
            </div>
            {filters.isClearable() && (
              <a
                href="javascript:;"
                className="generic-link clear-filters"
                onClick={() => onUpdateFilters(filters.clear())}>
                Clear Filters
              </a>
            )}
          </div>
          <div className="toggle-spacing-container">
            <ToggleField
              value={filters.unviewedOnly}
              onChange={unviewedOnly =>
                onUpdateFilters({
                  unviewedOnly,
                  pinnedOnly: unviewedOnly ? false : filters.pinnedOnly,
                })
              }
              label="Unread Only"
              labelPosition="left"
            />
            <ToggleField
              value={filters.pinnedOnly}
              onChange={pinnedOnly =>
                onUpdateFilters({
                  pinnedOnly,
                  unviewedOnly: pinnedOnly ? false : filters.unviewedOnly,
                })
              }
              label="Pinned Only"
              labelPosition="left"
            />
          </div>
        </div>
      </div>
    );
  }
}
